import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthMonitorService } from './auth/auth-monitor.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'My SalesMail';

  constructor(private authMonitor: AuthMonitorService) {}
}
